import React, { useEffect, useState } from "react";
import { getFormsDashboardSummary } from "../../api/work-order-formsAPI";

const metricsConfig = [
  {
    key: "inProgress",
    label: "Forms In Progress",
    badgeClass: "bg-primary-focus text-primary-main px-16 py-2",
  },
  {
    key: "inProgressOlderThan30Days",
    label: "> 30 Days In Progress",
    badgeClass: "bg-danger-focus text-danger-main px-12 py-2",
  },
  {
    key: "completedLast7Days",
    label: "Completed (7 Days)",
    badgeClass: "bg-success-focus text-success-main px-12 py-2",
  },
  {
    key: "completedLast30Days",
    label: "Completed (30 Days)",
    badgeClass: "bg-info-focus text-info-main px-12 py-2",
  },
];

const FormsSummaryCard = () => {
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSummary = async () => {
      try {
        setIsLoading(true);
        const data = await getFormsDashboardSummary();
        setSummary(data);
      } catch (err) {
        console.error("Failed to load forms dashboard summary", err);
        setError("Unable to load forms summary");
      } finally {
        setIsLoading(false);
      }
    };

    loadSummary();
  }, []);

  if (isLoading) {
    return (
      <div className='col-xxl-4'>
        <div className='card h-100'>
          <div className='card-body p-20 d-flex align-items-center justify-content-center'>
            <span className='text-secondary-600 text-sm'>Loading forms summary...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='col-xxl-4'>
        <div className='card h-100'>
          <div className='card-body p-20 d-flex align-items-center justify-content-center'>
            <span className='text-danger-main text-sm'>{error}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='col-xxl-4'>
      <div className='card h-100'>
        <div className='card-body p-20'>
          <h6 className='mb-3 fw-bold text-lg'>Forms Summary</h6>
          <div className='row g-3'>
            {metricsConfig.map(({ key, label, badgeClass }) => (
              <div key={key} className='col-sm-6 col-xs-6'>
                <div className='radius-12 overflow-hidden p-16 h-100 d-flex flex-column justify-content-between'>
                  <div className='text-center mb-3'>
                    <span className={`${badgeClass} rounded-pill fw-medium text-sm d-inline-block`}>
                      {label}
                    </span>
                  </div>
                  <div className='text-center'>
                    <h5 className='mb-0'>{summary?.[key] ?? 0}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormsSummaryCard;
